import React from 'react';
import ChatLogo from './ChatLogo';
import ThemeToggleButton from './ThemeToggleButton';
import { UserProfilePanel } from '../UserProfile';

const ChatHeader = ({ isLoading = false, title = 'How will you optimize your well-being today?' }) => {
  return (
    <header className="chat-header">
      <div className="header-content">
        <div className="logo-title-group">
          <div className="logo-container">
            <ChatLogo isLoading={isLoading} />
          </div>
          <h1 className="chat-title">{title}</h1>
        </div>
        <div className="header-actions">
          <ThemeToggleButton />
          <UserProfilePanel />
        </div>
      </div>
    </header>
  );
};

export default ChatHeader;
